<div class="signup-wrapper">
  <div class="auth-bg"></div>

  <div class="auth-content">
    <div class="brand-header">
      <img src="assets/logo.png" alt="Porra Mundial 2026" class="brand-logo" />
      <span class="brand-name">PORRA MUNDIAL 2026</span>
    </div>

    <div class="auth-card">
      <div class="auth-card-inner">
        <h2 class="form-title">Crear cuenta</h2>
        <p class="form-subtitle">Únete a la porra y empieza a competir.</p>

        <div class="field-group">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Email</mat-label>
            <input matInput type="email" autocomplete="email" [(ngModel)]="email" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Nombre y apellidos</mat-label>
            <input matInput autocomplete="name" [(ngModel)]="name" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Contraseña</mat-label>
            <input type="password" matInput autocomplete="new-password" [(ngModel)]="password" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Confirmar contraseña</mat-label>
            <input type="password" matInput autocomplete="new-password" [(ngModel)]="confirmPassword" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Código de acceso</mat-label>
            <input matInput [(ngModel)]="code" />
          </mat-form-field>
        </div>

        <button mat-flat-button color="primary" class="btn-cta" (click)="signup()">
          Registrarme
        </button>

        <div class="form-links">
          <button mat-button (click)="showLogin()" class="link-btn">
            ¿Ya tienes cuenta? Inicia sesión
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<block-ui></block-ui>
